<template>
  <div class="row">
    <div class="col text-center">
      <img src="/images/subloader.gif" :style="`width: ${width}px;`" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "miniloader",
  props: {
    width: {
      type: Number,
      default: 50,
    },
  }
}
</script>